import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";

import "../components/auto-nav";
import "../components/auto-footer";

@customElement("auto-fof")
export class AutoFof extends LitElement {
  render() {
    return html`
      <auto-nav></auto-nav>
      <main>
        <h1>Page Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
      </main>
      <auto-footer></auto-footer>
    `;
  }
}
